export default __webpack_public_path__ + "static/media/Connecticut2Closed.008fed0e.jpg";